import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20Japanese%20anime%20style%20background%20with%20warm%20golden%20amber%20and%20deep%20crimson%20ink%20wash%20brush%20strokes%2C%20ethereal%20flowing%20energy%20lines%20reminiscent%20of%20chakra%20and%20seal%20markings%2C%20traditional%20sumi-e%20painting%20texture%20blended%20with%20modern%20digital%20art%2C%20dramatic%20yet%20elegant%20composition%20with%20soft%20gradients%2C%20no%20characters%20visible%2C%20purely%20atmospheric%20artistic%20background&width=1800&height=900&seq=hero-tsunade-01&orientation=landscape"
          alt="纲手本子同人创作 - 火影忍者纲手角色艺术背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-4 leading-tight">
          纲手本子<span className="text-primary-400">·</span>高质量同人创作合集
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed mb-8">
          汇聚火影忍者纲手角色最优质的同人插画、漫画与故事创作，
          为每一位热爱纲手姬的资深火影粉丝打造深度内容平台。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/illustration"
            className="px-6 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-image-line mr-2"></i>浏览插画作品
          </Link>
          <Link
            to="/category/manga"
            className="px-6 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full font-medium text-sm hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line mr-2"></i>阅读同人漫画
          </Link>
        </div>

        <div className="mt-10 flex items-center justify-center gap-6 text-white/60 text-sm">
          <span><strong className="text-white text-lg">9+</strong> 精选作品</span>
          <span className="w-px h-4 bg-white/20"></span>
          <span><strong className="text-white text-lg">3</strong> 内容分类</span>
          <span className="w-px h-4 bg-white/20"></span>
          <span><strong className="text-white text-lg">每周</strong> 更新</span>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}